import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["carbon-plated-shoes"]!;

export function Body() {
  return (
    <>
      <p>
        Racing shoes with thick, bouncy foam and a stiff plate have changed road running. How
        much do they actually help? The first study of these shoes measured it directly.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers asked 18 fast runners to run on a treadmill in three pairs of shoes: a
        prototype with a new, highly resilient foam and a stiff embedded plate, and two
        established marathon racing shoes. They ran five-minute trials at 14, 16 and 18 km/h,
        while the researchers measured their oxygen uptake. Shoe weight was matched.
      </p>

      <h2>What they found</h2>
      <p>
        The new shoes lowered the energy cost of running by about 4 percent compared with both
        established racing shoes. All 18 runners used less energy in the new shoes, and the
        effect was the same at all three speeds.
      </p>

      <h2>What it means for you</h2>
      <p>
        A lower energy cost at the same pace means you can run faster for the same effort. For
        race day, these shoes can make a real difference.
      </p>
      <p>
        Many runners keep them for races and key sessions and do most of their training in
        ordinary shoes. If you switch to a new type of shoe, try it on shorter runs first, as it
        can feel different and load your feet and legs in new ways.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The runners were fast, and the slowest speed tested was 14 km/h, which is about 4:17 per
        km. How large the benefit is at slower paces was not measured. A lower energy cost on a
        treadmill also doesn't translate directly into the same percentage faster race time.
      </p>

      <h2>How we use it</h2>
      <p>
        Your pace targets in PX7 Training come from your races and tests. If you race in carbon
        shoes and train in ordinary ones, log which shoes you used in the race, as your race
        result may be a little faster than your training pace suggests.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Hoogkamer et al. (2018), A comparison of the energetic cost of running in marathon
          racing shoes.{" "}
          <a href="https://doi.org/10.1007/s40279-017-0811-2">Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
